<script>
import formatDate from '@utils/format-date.js'
import { mapGetters } from 'vuex'

export default {
  name: 'MessageChatBubble',
  props: {
    message: {
      type: Object,
      required: true,
    },
    last: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser',
    }),
    seenBySomeone() {
      if (!this.message.readBy) return ''

      return this.message.readBy === this.currentUser.id
        ? 'Seen by you'
        : 'Seen by someone'
    },
  },
  methods: {
    formatTimestamp(timestamp, format) {
      return !timestamp ? '' : formatDate(timestamp, format)
    },
  },
}
</script>

<template>
  <div :class="last ? 'islast' : ''">
    <div
      :class="['message', message.me ? 'send' : 'receive']"
      :data-message-id="message.id"
    >
      <div class="caption">
        <span class="message-bubble-sender-name font-weight-medium">{{
          message.senderName
        }}</span>
        <span
          class="message-bubble-sent-date mx-4"
          :title="formatTimestamp(message.timestamp, 'llll')"
          >{{ formatTimestamp(message.timestamp, 'hh:mm a') }}
        </span>
      </div>
      <div class="message-bubble-content">{{ message.content.trim() }}</div>
    </div>
    <div
      v-if="last && seenBySomeone"
      class="message-bubble-seen-by caption blue--text mb-4"
    >
      <v-icon x-small left color="blue">mdi-eye</v-icon> {{ seenBySomeone }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
</style>
